module.exports = __webpack_public_path__ + "img/banner03_mo.d28116dc.png";